module.exports = __webpack_public_path__ + "img/draganddrop-explanation-es.238dfab4.png";